<template>
  <div>
    <template v-for="(page,p) in menu">
      <component v-bind:is="page.component" v-bind:menuItem="page" :key="p"></component>
    </template>
  </div>
</template>

<script>
  import ParallaxImage from '@/components/sections/ParallaxImage';
  import Map from '@/components/sections/Map';
  import Gallery from '@/components/sections/Gallery';
  import CardSpace from '@/components/sections/CardSpace';
  import Contact from '@/components/sections/Contact';
  import TextAndImage from '@/components/sections/TextAndImage';
  import WideCards from '@/components/sections/WideCards';

  export default {
    components: {
      Contact,
      CardSpace,
      Gallery,
      ParallaxImage,
      Map,
      TextAndImage,
      WideCards,
    },
    props: [],
    data () {
      return {
      }
    },
    computed:{
      menu(){
        return this.$store.getters.menu();
      }
    },
    mounted () {
      console.log('mounted Parallax age')
    },
    methods: {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ParallaxPage.vue